var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"discount-scope"},[_vm._v(" "+_vm._s(_vm.$t('ctx.discount.detail.scope'))+" "),_c('b',[_vm._v(_vm._s(_vm.$t(_vm.currentScopeText)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }